import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/$walletId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/wallets/$walletId/summary',
      params: {
        walletId: params.walletId,
      },
      replace: true,
    });
  },
});
